export default "__VITE_ASSET__BtWTUHk9__"